<template>
  <div class="content">
    <base-header :choose-index="3"></base-header>
    <div class="middle_content">
      <swiper :options="swiperOption" class="swiper-container">
        <swiper-slide v-for="(item, index) in website_news_banner" :key="index">
          <div class="middle_content-post">
            <div class="middle_content-post-content">
              <div
                class="middle_content-post-content-pic"
                v-bgImg="utils.getQiniuWidthUrl(item.news_face, 790, 2, 'webp')"
              ></div>
              <div class="middle_content-post-content-pic-right">
                <div class="middle_content-post-content-pic-right-title">
                  <div
                    class="middle_content-post-content-pic-right-title-text duohang swiper-no-swiping"
                    @click="showNews(index, 0)"
                  >{{item.news_title}}</div>
                </div>
                <div
                  class="middle_content-post-content-pic-right-content swiper-no-swiping"
                >{{item.news_summary}}</div>
                <div
                  class="middle_content-post-content-pic-right-btn"
                  v-bgImg="require('@@/assets/img/westa/activity/btn.png')"
                  @click="showNews(index, 0)"
                ></div>
              </div>
            </div>
          </div>
        </swiper-slide>

        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
      <div class="news_list">
        <div
          class="news_list-item"
          v-for="(item, index) in website_news"
          :key="item.news_id"
          @click="showNews(index, 1)"
        >
          <div
            class="news_list-item-pic"
            v-bgImg="utils.getQiniuWidthUrl(item.news_face, 380, 2, 'webp')"
          ></div>
          <div class="news_list-item-title danhang">{{item.news_title}}</div>
          <div class="news_list-item-time">{{item.news_post_time}}</div>
        </div>
      </div>
      <div class="news_pagination">
        <el-pagination
          layout="prev, pager, next"
          background
          @current-change="getInfo"
          :current-page.sycn="page"
          :total="total"
          :page-size="6"
        ></el-pagination>
      </div>
    </div>
    <base-footer></base-footer>

    <el-dialog
      id="news_dialog"
      :title="chooseTitle"
      :visible.sync="centerDialogVisible"
      width="860px"
      center
    >
      <!-- <span>{{chooseContent}}</span> -->
      <HtmlContent :html_content="decodeURIComponent(chooseContent)" v-if="chooseContent"></HtmlContent>
    </el-dialog>
  </div>
</template>

<script>
import BaseHeader from "@@/components/westa/base-header";
import BaseFooter from "@@/components/westa/base-footer";
import HtmlContent from "@/common/html_content/html_content";
export default {
  data() {
    return {
      page: 1,
      total: 0,
      swiperOption: {
        autoplay: true,
        autoplay: {
          disableOnInteraction: false
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
          renderBullet(index, className) {
            return `<span class="${className} swiper-pagination-bullet-custom"></span>`;
          }
        }
      },
      centerDialogVisible: false,
      website_news_banner: [],
      website_news: [],
      chooseTitle: "",
      chooseContent: ""
    };
  },
  components: {
    BaseHeader,
    BaseFooter,
    HtmlContent
  },
  created() {
    this.getBanner();
    this.getInfo(1);
  },
  mounted() {},
  methods: {
    getBanner() {
      let params = {};
      this.req
        .get(
          url_api_web_websiteNews_getWebsiteNewsBanner,
          this.qs.stringify(params)
        )
        .then(result => {
          this.website_news_banner = result.website_news;
        })
        .catch(error => {});
    },
    getInfo(page) {
      if (page != null) {
        this.page = page;
      }
      let params = {
        page: this.page - 1,
        page_count: 6
      };
      this.req
        .get(url_api_web_websiteNews_getWebsiteNews, this.qs.stringify(params))
        .then(result => {
          this.website_news = result.website_news;
          this.total = result.total;
          console.log(this.total);
          let len = this.website_news.length;
          for (let i = 0; i < len; i++) {
            let date = new Date(this.website_news[i].news_post_time * 1000);
            let Y = date.getFullYear();
            let M =
              date.getMonth() + 1 < 10
                ? "0" + (date.getMonth() + 1)
                : date.getMonth() + 1;
            let D = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
            this.website_news[i].news_post_time = Y + "-" + M + "-" + D;
          }
        })
        .catch(error => {});
    },
    showNews(index, qudao) {
      if (qudao === 0) {
        this.chooseTitle = this.website_news_banner[index].news_title;
        this.chooseContent = this.website_news_banner[index].news_content;
      } else {
        this.chooseTitle = this.website_news[index].news_title;
        this.chooseContent = this.website_news[index].news_content;
      }
      this.centerDialogVisible = true;
      this.$nextTick(() => {
        document.querySelector("#news_dialog").scrollTop = 0;
      });
    }
  }
};
</script>


<style lang="less" scoped>
.content {
  // font-family: "SourceHanSansCN";
}
.middle_content {
  padding-top: 64px;
  background: #f2f2f2;
  min-width: 1200px;

  &-post {
    width: 100%;
    height: auto;
    background: #f2f2f2;
    &-content {
      width: 1200px;
      margin: 0 auto;

      margin-top: 50px;
      margin-bottom: 64px;
      display: flex;
      box-shadow: 0 2px 6px 0 rgba(24, 31, 153, 0.06);
      &-pic {
        width: 618px;
        height: 400px;
        position: relative;
        &-right {
          // position: absolute;
          width: 582px;
          height: 400px;
          // top: 48px;
          // left: 692px;
          padding: 48px;
          box-sizing: border-box;
          background: #fff;
          &-title {
            font-size: 24px;

            height: 96px;
            &-text {
              cursor: pointer;
              &:hover {
                color: #181f99;
              }
            }
          }
          &-content {
            height: 180px;
            color: #999;
            font-size: 16px;
            // overflow-y: scroll;
            // overflow-x: hidden;
            overflow: hidden;
            // word-wrap: wrap;
            white-space: pre-wrap;
            word-wrap: break-word;
            word-break: break-all;
          }
          &-btn {
            width: 146px;
            height: 54px;
            margin: 0 auto;
            margin-top: 10px;
            cursor: pointer;
          }
        }
      }
    }
  }
}
.news_list {
  width: 1200px;
  height: 850px;
  margin: 0 auto;
  padding-top: 54px;
  display: flex;
  flex-wrap: wrap;
  &-item {
    width: 380px;
    height: 360px;
    font-size: 16px;
    margin-right: 30px;
    background: #fff;
    // padding-bottom: 44px;
    // box-sizing: border-box;
    &-pic {
      width: 380px;
      height: 212px;
      cursor: pointer;
    }
    &-title {
      height: 60px;
      // color: #666;
      margin-top: 30px;
      padding: 0 20px;
      box-sizing: border-box;
      font-weight: bold;
      font-size: 18px;
      cursor: pointer;
      &:hover {
        color: #181f99;
      }
    }
    &-time {
      color: #999;
      padding: 0 20px;
      box-sizing: border-box;
      // text-align: right;
      // margin-top: 25px;
    }
    &:hover {
      box-shadow: 0 2px 6px 0 rgba(24, 31, 153, 0.06);
    }
    &:nth-child(3n) {
      margin-right: 0;
    }
  }
}
.news_pagination {
  display: flex;
  justify-content: flex-end;
  width: 1200px;
  margin: 0 auto;
  padding: 20px 0;
}
.danhang {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.duohang {
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
</style>



